// ==============================|| PRESET THEME - DEFAULT ||============================== //

import { lightBlue, lime, purple, teal } from "@mui/material/colors";

const Default = (colors) => {
	const primary = {
		50: '#FAFAFA',
		100: '#F2F5F5',
		200: '#E8EBEC',
		300: '#D5DADD',
		400: '#BAC2C6',
		500: '#9EA9AE',
		main: '#869197',
		600: '#737E84',
		800: '#5E666B',
		900: '#4C5357',
		950: '#31373A'
	}
	
	const primaryWithOpacity = {
		10: '#737E8419',
		20: '#737E8433',
		30: '#737E844C',
		40: '#737E8466',
		50: '#737E847F',
		60: '#737E8499',
		70: '#737E84B2',
		80: '#737E84CC',
		90: '#737E84E5'
	}
	
	const secondary = {
		50: '#F8F7F8',
		100: '#F0EEEE',
		200: '#DED9DA',
		300: '#C1B8BB',
		400: '#9F9196',
		500: '#847379',
		600: '#6C5D62',
		700: '#584C50',
		800: '#4B4144',
		900: '#41393B',
		main: '#242021',
	}
	
	const secondaryWithOpacity = {
		10: '#24202119',
		20: '#24202133',
		30: '#2420214C',
		40: '#24202166',
		50: '#2420217F',
		60: '#24202199',
		70: '#242021B2',
		80: '#242021CC',
		90: '#242021E5'
	}
	
	const highlight = {
		50: '#ECF4FF',
		100: '#DDEAFF',
		200: '#C2D8FF',
		300: '#9CBCFF',
		400: '#7595FF',
		main: '#647DFF',
		600: '#3646F5',
		dark: '#2A35D8',
		700: '#2A35D8',
		800: '#2530AE',
		900: '#263189',
		950: '#161A50',
		contrastText: '#fff'
	}
	
	const info = {
		50: '#F0F9FF',
		lighter: '#E0F2FE',
		100: '#E0F2FE',
		200: '#B9E6FE',
		300: '#7CD3FD',
		400: '#36BDFA',
		500: '#0CA5EB',
		main: '#008AD2',
		600: '#008AD2',
		700: '#0169A3',
		800: '#065986',
		900: '#0B4A6F',
		950: '#072F4A',
		contrastText: '#fff'
	}
	
	const error = {
		lighter: '#FFF1F1',
		50: '#FFF1F1',
		100: '#FFDFDF',
		200: '#FFC4C4',
		300: '#FF9B9B',
		400: '#FF6161',
		main: '#FF6161',
		500: '#FF3030',
		600: '#F11111',
		dark: '#C00909',
		700: '#C00909',
		800: '#A80C0C',
		900: '#8B1111',
		950: '#4C0303',
		contrastText: '#fff'
	}
	
	const success = {
		lighter: '#EEFBF4',
		50: '#EEFBF4',
		100: '#D6F5E2',
		200: '#B0EACA',
		300: '#7DD8AC',
		400: '#48BF8A',
		500: '#2ABB7F',
		main: '#2ABB7F',
		600: '#178459',
		700: '#126A4A',
		dark: '#126A4A',
		800: '#11543B',
		900: '#0F4533',
		950: '#07271C',
		contrastText: '#fff'
	}
	
	const warning = {
		lighter: '#FFFBEA',
		50: '#FFFBEA',
		100: '#FFF3C5',
		200: '#FFE787',
		300: '#FFD448',
		400: '#FFBF1E',
		500: '#FC9D04',
		main: '#FC9D04',
		600: '#E77900',
		700: '#B95004',
		800: '#963D0A',
		900: '#7B330C',
		950: '#471801',
		contrastText: '#fff'
	}
	
	const white = {
		main: '#FFFFFF'
	}
	
	const whiteWithOpacity = {
		10: '#FFFFFF19',
		20: '#FFFFFF33',
		30: '#FFFFFF4C',
		40: '#FFFFFF66',
		50: '#FFFFFF7F',
		60: '#FFFFFF99',
		70: '#FFFFFFB2',
		80: '#FFFFFFCC',
		90: '#FFFFFFE5'
	}
	return {
		primary,
		primaryWithOpacity,
		secondary,
		secondaryWithOpacity,
		highlight,
		info,
		success,
		error,
		warning,
		white,
		whiteWithOpacity,
		background: {
			primary: '#f4f4f5',
			primaryWithOpacity,
			secondary,
			secondaryWithOpacity,
			highlight: {
				50: highlight[50],
				100: highlight[100],
				200: highlight[200],
				300: highlight[300],
				main: highlight.main,
				600: highlight[600],
				700: highlight[700],
				800: highlight[800],
				900: highlight[900],
				950: highlight[950]
			},
			white,
			whiteWithOpacity,
			info,
			success,
			warning,
			error
		},
		text: {
			main: primary[800],
			primary: primary.main,
			secondary: secondary.main,
			disabled: highlight[300]
			// primaryWithOpacity,
			// secondary,
			// secondaryWithOpacity,
			// highlight,
			// white,
			// whiteWithOpacity,
			// success: {
			// 	50: success[50],
			// 	100: success[100],
			// 	200: success[200],
			// 	300: success[300],
			// 	main: success[500],
			// 	600: success[600],
			// 	700: success[700],
			// 	800: success[800],
			// 	900: success[900],
			// 	950: success[950]
			// }
		},
		sector: {
			blue: {
				50: info[50],
				100: info[100],
				200: info[200],
				300: info[300],
				400: info[400],
				500: info[500],
				700: info[600],
				main: info[700],
				800: info[800],
				900: info[900],
				950: info[950]
			},
			red: {
				50: error[50],
				100: error[100],
				200: error[200],
				300: error[300],
				400: error[400],
				500: error[500],
				600: error[600],
				main: error[700],
				800: error[800],
				900: error[900],
				950: error[950]
			},
			orange: {
				50: warning[50],
				100: warning[100],
				200: warning[200],
				300: warning[300],
				400: warning[400],
				500: warning[500],
				main: warning[600],
				700: warning[700],
				800: warning[800],
				900: warning[900],
				950: warning[950]
			}
		},
		step1: {
			contrastText: '#1A2027',
			main: lime["200"],
		},
		step2: {
			contrastText: '#1A2027',
			main: teal["200"],
		},
		step3: {
			contrastText: '#1A2027',
			main: lightBlue["200"],
		},
		step4: {
			contrastText: '#1A2027',
			main: purple["200"],
		},
		step5: {
			contrastText: '#1A2027',
			main: teal.A400,
		},
		step6: {
			contrastText: '#fff',
			main: lightBlue.A700,
		},
		...colors
	};
};

export default Default;
